<template>
  <div class="relative inline-flex">
    <button
      @click.stop="$emit('toggle', colKey)"
      type="button"
      class="w-4 h-4 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-500 hover:text-gray-700 flex items-center justify-center text-[10px] font-semibold leading-none transition-colors normal-case tracking-normal"
      :title="info"
    >?</button>
    <!-- Right-anchored so it grows leftward — column headers are
         text-right and the right-most cells would otherwise push
         horizontal scroll. -->
    <div
      v-if="active"
      @click.stop
      class="absolute right-0 top-full mt-2 z-50 w-64 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-sm font-normal text-gray-600 leading-relaxed normal-case tracking-normal text-left"
    >{{ info }}</div>
  </div>
</template>

<script>
/**
 * Column-header info popover. Renders a `?` chip beside a table
 * header label; clicking toggles a small popover with definition
 * copy. The parent owns `active` state via an `activeHeader` slot
 * and an exclusive toggle so only one column popover is open at a
 * time. Outside-click dismissal is wired up by the parent.
 */
export default {
  name: 'ColumnInfo',
  emits: ['toggle'],
  props: {
    colKey: { type: String, required: true },
    active: { type: Boolean, default: false },
    info:   { type: String, required: true }
  }
}
</script>
